import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// i18n for legacy components
import { withTranslation, Trans } from 'react-i18next';

// Custom HOCs
import { withRouter } from '../../helpers/hocs';

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faUser } from '@fortawesome/free-solid-svg-icons';

import { Modal, ModalBody, ModalHeader } from 'reactstrap';

// Actions
import { gameActions } from '../../actions';
import { setupSocket, enterBackend, socketOn } from '../../helpers/sockets';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';

// Add FontAwesome icons
library.add(faCheck);
library.add(faUser);

const cat_labels = {
  connection_questions: <Trans i18nKey='Connection' />,
  basic_questions: <Trans i18nKey='Basic' />,
  value_based: <Trans i18nKey='Value-Based' />,
  other: <Trans i18nKey='Other' />,
  excavation_questions: <Trans i18nKey='Excavation' />,
  c_questions: <Trans i18nKey='Clarification' />,
  exploration_questions: <Trans i18nKey='Exploration' />,
  action_questions: <Trans i18nKey='Action' />,
};
const color_badge = {
  value_based: 'text-bg-success border border-success font-weight-bolder',
  basic_questions: 'text-bg-warning border border-warning',
  other: 'text-bg-secondary border border-secondary',
  excavation_questions: 'text-bg-primary border border-primary',
  connection_questions: 'text-bg-primary border border-primary',
  c_questions: 'text-bg-primary border border-primary',
  exploration_questions: 'text-bg-primary border border-primary',
  action_questions: 'text-bg-primary border border-primary',
};

// The component definition
class DebriefProposals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_player: null,
      definitions: [],
      proposals: [],
    };

    // Bindings
    this.setProposals = this.setProposals.bind(this);
    this.toggleDescription = this.toggleDescription.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    if (match.params.id) {
      // dispatch(gameActions.fetchGames(match.params.id))
      fetch(process.env.REACT_APP_API_URL + '/auth/oauth_provider')
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          setupSocket(data.io_domain, () => {
            enterBackend({ game_id: match.params.id }, (socketGameData) => {
              console.log({ socketGameData });
            });
            // Sockets!
            socketOn('offer', (m) => {
              dispatch(gameActions.fetchGames(match.params.id));
            }); // socketOn('nodeal', (m) => console.log(m) );
          });
        });
    }
  }

  setProposals(proposals) {
    // Avoid repeated proposals. Use the player_id property
    const unique = proposals.filter(
      (v, i, a) => a.findIndex((t) => t.player_id === v.player_id) === i,
    );
    this.setState({ proposals: unique });
  }

  toggleDescription(index) {
    const { definitions } = this.state;
    definitions[index] = !definitions[index];
    this.setState({ definitions });
  }

  render() {
    const { game, t } = this.props;
    const { selected_player } = this.state;
    if (!game.data) return null;

    // Proposals data
    const proposals1 = game.data.results.filter((r) => r.proposal === 1);
    const proposals2 = game.data.results.filter((r) => r.proposal === 2);
    const proposals3 = game.data.results.filter((r) => r.proposal === 3);

    // Discussion
    const thePlayer = selected_player
      ? game.data.players.find((pl) => pl._id === selected_player)
      : null;
    const timelineEls = thePlayer
      ? thePlayer.chat.map((o, oi) => {
          const mine = thePlayer.email === o.from ? true : false;
          const authorName = mine ? thePlayer.name || thePlayer.email : 'David';
          let roleAlign = mine
            ? 'text-end text-kellogg d-inline-block'
            : 'text-start d-inline-block text-dark';
          let roleBox = mine
            ? 'float-end text-end bg-kellogg text-white d-inline-block border-card-r border-0'
            : 'float-start d-inline-block bg-kellogg-light text-dark border-card-l border-0';
          const roleName = mine ? 'You' : 'Purchasing Manager';

          roleAlign = !o.from ? 'text-center' : roleAlign;
          roleBox = !o.from ? 'bg-white' : roleBox;

          let direction = mine ? 'row-reverse' : 'row';

          return (
            <div key={`m-${oi}`} className='clearfix message'>
              <div
                style={{ display: 'flex', flexDirection: direction }}
                className='mb-2'>
                {o.from !== 'system' && (
                  <div
                    className={roleBox + ' mx-2 text-center bg-kellogg-dark'}
                    style={{
                      padding: '8px 12px',
                      width: '40px',
                      borderRadius: '50%',
                      marginTop: 'auto',
                    }}>
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                )}

                {/* System message */}
                {o.from === 'system' && (
                  <div className='card alert alert-warning text-center py-2 w-100'>
                    {o.msg === '[PROPOSAL]'
                      ? t('Proposal #{{proposal}} Submitted', {
                          proposal: o.data,
                        })
                      : null}
                  </div>
                )}

                {/* Players message */}
                {o.from !== 'system' && (
                  <div
                    className={'card ' + roleBox}
                    style={{ minWidth: '60%', maxWidth: '80%' }}>
                    <div className={roleAlign} style={{ padding: '10px 15px' }}>
                      {o.msg}
                      {o.from && (
                        <div>
                          <small>
                            <b>
                              {authorName} ({roleName})
                            </b>
                          </small>
                        </div>
                      )}
                      {/* {o.from && <br />} */}

                      {/* CLASSIFICATION */}
                      {/* <div>
                {o.cat_main ? (
                  <small className='badge badge-primary'>
                    {cat_labels[o.cat_main]}
                  </small>
                ) : null}
                {o.cat_ksi ? (
                  <small className='badge badge-primary ms-2'>
                    {cat_labels[o.cat_ksi]}
                  </small>
                ) : null}
              </div> */}
                    </div>
                  </div>
                )}
              </div>
              <div className='clearfix'></div>
              {o.from !== 'system' && (
                <div className='text-end mb-4' style={{ marginRight: '58px' }}>
                  {o.cat_main ? (
                    <small className={'badge p-2 ' + color_badge[o.cat_main]}>
                      {cat_labels[o.cat_main]}
                    </small>
                  ) : null}
                  {o.cat_ksi ? (
                    <small
                      className={'badge p-2 ms-2 ' + color_badge[o.cat_ksi]}>
                      {cat_labels[o.cat_ksi]}
                    </small>
                  ) : null}
                </div>
              )}
            </div>
          );
        })
      : [];

    // COMPOSITION
    // Get players for each proposals group
    var prop1Players = proposals1.map(function (prop) {
      return game.data.players.find(function (p) {
        return p.email === prop.player;
      });
    });
    var prop2Players = proposals2.map(function (prop) {
      return game.data.players.find(function (p) {
        return p.email === prop.player;
      });
    });
    var prop3Players = proposals3.map(function (prop) {
      return game.data.players.find(function (p) {
        return p.email === prop.player;
      });
    });

    const classTags1 = {
      connection_questions: [],
      basic_questions: [],
      value_based: [],
      other: [],
    };
    prop1Players.forEach(function (player) {
      if (!player.chat) return;
      player.chat.forEach(function (msg) {
        // Get the main  classes
        const { cat_main } = msg;

        // Assign the main class to the bucket
        if (cat_main?.length > 0) {
          if (classTags1?.[cat_main]) {
            classTags1[cat_main].push(1);
          } else {
            classTags1['other'].push(1);
          }
        }
      });
    });

    const classTags2 = {
      connection_questions: [],
      basic_questions: [],
      value_based: [],
      other: [],
    };
    prop2Players.forEach(function (player) {
      if (!player.chat) return;
      player.chat.forEach(function (msg) {
        // Get the main classes
        const { cat_main } = msg;

        // Assign the main class to the bucket
        if (cat_main?.length > 0) {
          if (classTags2?.[cat_main]) {
            classTags2[cat_main].push(1);
          } else {
            classTags2['other'].push(1);
          }
        }
      });
    });

    var classTags3 = {
      connection_questions: [],
      basic_questions: [],
      value_based: [],
      other: [],
    };
    prop3Players.forEach(function (player) {
      if (!player.chat) return;
      player.chat.forEach(function (msg) {
        // Get the main classes
        const { cat_main } = msg;

        // Assign the main class to the bucket
        if (cat_main?.length > 0) {
          if (classTags3?.[cat_main]) {
            classTags3[cat_main].push(1);
          } else {
            classTags3['other'].push(1);
          }
        }
      });
    });

    return (
      <div>
        <Header />

        <h2 className='mt-3 sec-title fs-3'>
          {t('Proposals')}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2>

        <div className='mt-3 pb-2 row'>
          <div className='col-12'>
            <div
              className='row bg-white mb-3 pb-3'
              style={{
                minHeight: '78vh',
              }}>
              <div className='col-4 p-3'>
                <div className='card'>
                  <div className='card-body'>
                    <h5>{t('Proposal 1')}</h5>
                    <i className='text-secondary'>
                      {t('Maintain 2% year-over-year price reductions.')}
                    </i>
                    <br />
                    <br />

                    <hr />

                    <p>
                      <b>
                        {prop1Players.length > 0
                          ? t('Submissions: {{count}}', {
                              count: prop1Players.length,
                            })
                          : t('No submissions')}
                      </b>
                    </p>

                    <HighchartsReact
                      highcharts={Highcharts}
                      options={{
                        chart: {
                          type: 'pie',
                          style: { fontSize: '14px' },
                          height: '180px',
                          marginTop: -75,
                        },
                        credits: { enabled: false },
                        title: {
                          text: '',
                        },
                        xAxis: {
                          labels: { style: { fontSize: '14px' } },
                        },
                        yAxis: {
                          labels: { style: { fontSize: '14px' } },
                          allowDecimals: false,
                          min: 0,
                          title: {
                            text: '',
                          },
                        },
                        plotOptions: {
                          pie: {
                            dataLabels: {
                              enabled: true,
                              distance: -10,
                              x: -10,
                              y: -10,
                              style: {
                                fontWeight: 'bold',
                                color: 'white',
                              },
                            },
                            startAngle: -90,
                            endAngle: 90,
                            center: ['50%', '115%'],
                            size: '130%',
                            // Simulating a disabled state
                            // Simulating a disabled state
                            ...(prop1Players.length === 0 && {
                              borderWidth: 45,
                            }),
                          },
                        },
                        series: [
                          {
                            name: t('Proposal 1'),
                            innerSize: '70%',
                            data: Object.values(classTags1).some(
                              (v) => v?.length > 0,
                            )
                              ? [
                                  // {
                                  //   name: 'Connection',
                                  //   y: classTags1.connection_questions.length,
                                  //   color: '#4a90e2',
                                  // },
                                  {
                                    name: t('Basic'),
                                    y: classTags1.basic_questions.length,
                                    color: '#f0c362',
                                  },
                                  {
                                    name: t('Value-Based'),
                                    y: classTags1.value_based.length,
                                    color: '#4aa987',
                                  },
                                  {
                                    name: t('Other'),
                                    y: classTags1.other.length,
                                    color: '#aaa',
                                  },
                                ]
                              : [],
                          },
                        ],
                      }}
                    />

                    <hr />

                    <div className='d-flex'>
                      <button
                        disabled={prop1Players.length === 0}
                        className='btn btn-sm btn-outline-primary'
                        onClick={() => this.setProposals(proposals1)}>
                        <FontAwesomeIcon icon='user-friends' className='me-2' />
                        {t('Identify Learners')}
                      </button>
                      <button
                        className='btn btn-link ms-auto pl-0'
                        onClick={() => this.toggleDescription(0)}>
                        {!this.state.definitions[0]
                          ? t('Show details')
                          : t('Hide details')}
                      </button>
                    </div>

                    {this.state.definitions[0] && (
                      <p className='mt-3 mb-0 text-muted'>
                        {t('proposal_1_description')}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className='col-4 p-3'>
                <div className='card'>
                  <div className='card-body'>
                    <h5>{t('Proposal 2')}</h5>
                    <i className='text-secondary'>
                      {t('Fixed price | Include delivery time guarantees.')}
                    </i>
                    <br />
                    <br />

                    <hr />

                    <p>
                      <b>
                        {prop2Players.length > 0
                          ? t('Submissions: {{count}}', {
                              count: prop2Players.length,
                            })
                          : t('No submissions')}
                      </b>
                    </p>

                    <HighchartsReact
                      highcharts={Highcharts}
                      options={{
                        chart: {
                          type: 'pie',
                          style: { fontSize: '14px' },
                          height: '180px',
                          marginTop: -75,
                        },
                        credits: { enabled: false },
                        title: {
                          text: '',
                        },
                        xAxis: {
                          labels: { style: { fontSize: '14px' } },
                        },
                        yAxis: {
                          labels: { style: { fontSize: '14px' } },
                          allowDecimals: false,
                          min: 0,
                          title: {
                            text: '',
                          },
                        },
                        plotOptions: {
                          pie: {
                            dataLabels: {
                              enabled: true,
                              distance: -10,
                              x: -10,
                              y: -10,
                              style: {
                                fontWeight: 'bold',
                                color: 'white',
                              },
                            },
                            startAngle: -90,
                            endAngle: 90,
                            center: ['50%', '115%'],
                            size: '130%',
                            // Simulating a disabled state
                            ...(prop2Players.length === 0 && {
                              borderWidth: 45,
                            }),
                          },
                        },
                        series: [
                          {
                            name: t('Proposal 2'),
                            innerSize: '70%',
                            data: Object.values(classTags2).some(
                              (v) => v?.length > 0,
                            )
                              ? [
                                  // {
                                  //   name: 'Connection',
                                  //   y: classTags2.connection_questions.length,
                                  //   color: '#4a90e2',
                                  // },
                                  {
                                    name: t('Basic'),
                                    y: classTags2.basic_questions.length,
                                    color: '#f0c362',
                                  },
                                  {
                                    name: t('Value-Based'),
                                    y: classTags2.value_based.length,
                                    color: '#4aa987',
                                  },
                                  {
                                    name: t('Other'),
                                    y: classTags2.other.length,
                                    color: '#aaa',
                                  },
                                ]
                              : [],
                          },
                        ],
                      }}
                    />

                    <hr />

                    <div className='d-flex'>
                      <button
                        disabled={prop2Players.length === 0}
                        className='btn btn-sm  btn-outline-primary'
                        onClick={() => this.setProposals(proposals2)}>
                        <FontAwesomeIcon icon='user-friends' className='me-2' />
                        {t('Identify Learners')}
                      </button>
                      <button
                        className='btn btn-link ms-auto pl-0'
                        onClick={() => this.toggleDescription(1)}>
                        {!this.state.definitions[1]
                          ? t('Show details')
                          : t('Hide details')}
                      </button>
                    </div>

                    {this.state.definitions[1] && (
                      <p className='mt-3 mb-0 text-muted'>
                        {t('proposal_2_description')}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className='col-4 p-3'>
                <div className='card'>
                  <div className='card-body'>
                    <h5>{t('Proposal 3')}</h5>
                    <i className='text-secondary'>
                      {t(
                        'Fixed price | Offer paid services to improve up-time.',
                      )}
                    </i>
                    <br />
                    <br />

                    <hr />

                    <p>
                      <b>
                        {prop3Players.length > 0
                          ? t('Submissions: {{count}}', {
                              count: prop3Players.length,
                            })
                          : t('No submissions')}
                      </b>
                    </p>

                    <HighchartsReact
                      highcharts={Highcharts}
                      options={{
                        chart: {
                          type: 'pie',
                          style: { fontSize: '14px' },
                          height: '180px',
                          marginTop: -75,
                        },
                        credits: { enabled: false },
                        title: {
                          text: '',
                        },
                        xAxis: {
                          labels: { style: { fontSize: '14px' } },
                        },
                        yAxis: {
                          labels: { style: { fontSize: '14px' } },
                          allowDecimals: false,
                          min: 0,
                          title: {
                            text: '',
                          },
                        },
                        plotOptions: {
                          pie: {
                            dataLabels: {
                              enabled: true,
                              distance: -10,
                              x: -10,
                              y: -10,
                              style: {
                                fontWeight: 'bold',
                                color: 'white',
                              },
                            },
                            startAngle: -90,
                            endAngle: 90,
                            center: ['50%', '115%'],
                            size: '130%',
                            // Simulating a disabled state
                            ...(prop3Players.length === 0 && {
                              borderWidth: 45,
                            }),
                          },
                        },
                        series: [
                          {
                            name: t('Proposal 3'),
                            innerSize: '70%',
                            data: Object.values(classTags3).some(
                              (v) => v?.length > 0,
                            )
                              ? [
                                  // {
                                  //   name: 'Connection',
                                  //   y: classTags3.connection_questions.length,
                                  //   color: '#4a90e2',
                                  // },
                                  {
                                    name: t('Basic'),
                                    y: classTags3.basic_questions.length,
                                    color: '#f0c362',
                                  },
                                  {
                                    name: t('Value-Based'),
                                    y: classTags3.value_based.length,
                                    color: '#4aa987',
                                  },
                                  {
                                    name: t('Other'),
                                    y: classTags3.other.length,
                                    color: '#aaa',
                                  },
                                ]
                              : [],
                          },
                        ],
                      }}
                    />

                    <hr />

                    <div className='d-flex'>
                      <button
                        disabled={prop3Players.length === 0}
                        className='btn btn-outline-primary btn-sm'
                        onClick={() => this.setProposals(proposals3)}>
                        <FontAwesomeIcon icon='user-friends' className='me-2' />
                        {t('Identify Learners')}
                      </button>
                      <button
                        className='btn btn-link ms-auto pl-0'
                        onClick={() => this.toggleDescription(2)}>
                        {!this.state.definitions[1]
                          ? t('Show details')
                          : t('Hide details')}
                      </button>
                    </div>

                    {this.state.definitions[2] && (
                      <p className='mt-3 mb-0 text-muted'>
                        {t('proposal_3_description')}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.proposals.length > 0 ? true : false}
          centered={true}
          size='xxl'
          toggle={() =>
            this.setState({ proposals: [], selected_player: null })
          }>
          <ModalHeader
            toggle={() =>
              this.setState({ proposals: [], selected_player: null })
            }>
            <FontAwesomeIcon icon='user-friends' className='me-2' />
            {t('Learners')} -{' '}
            <span className='font-weight-light'>
              {t('Proposal #{{number}}', {
                number: this.state.proposals[0]?.proposal,
              })}
            </span>
          </ModalHeader>
          <ModalBody className='text-center mx-2'>
            <div className='row'>
              <div className='col-3 text-start'>
                <h6 className='mb-3'>{t('Learners')}</h6>
                {this.state.proposals.map((p, pi) => {
                  const pl = game.data.players.find(
                    (gp) => gp._id === p.player_id,
                  );
                  const author = `${pl.name} ${pl.lastname}`.trim().length
                    ? `${pl.name} ${pl.lastname}`
                    : pl.email;
                  return (
                    <button
                      key={`p-${pi}`}
                      className={`btn d-block w-100 btn-lg ${
                        this.state.selected_player === pl._id
                          ? 'border-primary text-dark font-weight-normal'
                          : 'text-secondary font-weight-light'
                      } mb-3`}
                      style={{
                        borderWidth:
                          this.state.selected_player === pl._id ? '2px' : '1px',
                        borderColor:
                          this.state.selected_player === pl._id ? '' : '#BBB',
                      }}
                      onClick={() =>
                        this.setState({ selected_player: pl._id })
                      }>
                      {author}
                    </button>
                  );
                })}
              </div>
              <div className='col-9 text-start'>
                <h6 className='mb-3'>{t('Discussion')}</h6>
                <div
                  className='border'
                  style={{ height: '60vh', overflow: 'auto' }}>
                  <div className='card border-0'>
                    <div className='card-body p-4'>
                      {selected_player ? (
                        timelineEls
                      ) : (
                        <p className='text-center mb-0 pt-5 pb-5 lead'>
                          {t('Click on a student from the list.')}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

// With params
const DebriefProposalsWithRouters = withRouter(DebriefProposals);

// With translation
const DebriefProposalsWithTranslation = withTranslation()(
  DebriefProposalsWithRouters,
);

const mapStateToProps = (state) => {
  const { game } = state;
  return {
    game,
  };
};

export default connect(mapStateToProps)(DebriefProposalsWithTranslation);
